import { useEffect, useState } from "react";
import { Message } from "google-protobuf";

// Calls fetch with a serialized proto, then calls the responseHandler
// with the response.
//
// If the responseHandler throws an error, that error is set on the error
// field. The loading variable is not set back to false until the
// responseHandler call completes (unless the HTTP request fails and there
// is no response).
export default function useHTTPProtoPost(url, responseHandler) {
  const [request, setRequest] = useState(null);
  const [currentRequest, setCurrentRequest] = useState(null);

  const [loading, setLoading] = useState(false);
  const [called, setCalled] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Message objects are recreated on each render and equality checks don't
    // work, so we need to check equality ourselves to avoid re-triggering the
    // query below.
    if (!Message.equals(currentRequest, request)) {
      setCurrentRequest(request);
    }
  }, [request, currentRequest]);

  useEffect(() => {
    if (!currentRequest) {
      return;
    }

    setCalled(true);
    setLoading(true);
    setError(null);

    const body = currentRequest.serializeBinary();

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-protobuf"
      },
      redirect: "error",
      body
    })
      .then(response => {
        return responseHandler(response);
      })
      .catch(e => {
        setError(e);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [currentRequest, responseHandler, url]);

  return [setRequest, { loading, error, called }];
}
